import { Blood } from "../assets/models/bodyparts/blood";
import { Bones } from "../assets/models/bodyparts/bones";
import { Brain } from "../assets/models/bodyparts/brain";
import { Digestive } from "../assets/models/bodyparts/digestive";
import { Eyes } from "../assets/models/bodyparts/eyes";
import { Heart } from "../assets/models/bodyparts/heart";
import { Liver } from "../assets/models/bodyparts/liver";

export enum BODYPART {
  BLOOD = "BLOOD",
  BONES = "BONES",
  BRAIN = "BRAIN",
  DIGESTIVE = "DIGESTIVE",
  EYES = "EYES",
  HEART = "HEART",
  LIVER = "LIVER",
}

export const BodyPartDictionary = {
  BLOOD: Blood,
  BONES: Bones,
  BRAIN: Brain,
  DIGESTIVE: Digestive,
  EYES: Eyes,
  HEART: Heart,
  LIVER: Liver,
};
